<template>
  <div class="book-item">
      <div class="book-cover">
        <img :src="book.img" :alt="`${book.title} Cover`">
      </div>
      <div>
          <header>
            <div>
                <strong>{{book.title}}</strong>
                <span>{{book.author}}</span>
            </div>
            <a class="buy-button" :href="book.ref" target="_blank"><i><img src="@/assets/images/icons/amazon-tile.svg" alt="Amazon"></i>Buy from Amazon</a>
          </header>
          <p>
              {{book.summary}}
          </p>
      </div>
  </div>
</template>

<script>
export default {
    props: ["book"],
}
</script>

<style>
.book-item{
    display: flex;
    flex-direction: row;
    /* flex-wrap: wrap; */
    justify-content: flex-start;
    padding: 2rem 0;
}
.book-item img{
    display: block;
    width: 8rem;
    height: auto;
    /* width: 150px; */
    margin-right: 1.2rem;
}

.book-item > div{
    display: flex;
    flex-direction: column;
}

.book-item > div header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.book-item > div header div{
    display: flex;
    flex-direction: column;
}
.book-item > div strong{
    font-size: 1.2rem;
}
.book-item > div p{
    text-align: justify;
}
.book-item > div footer{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.buy-button {
  box-sizing: border-box;
  background-color: #555555;
  border: none;
  color: white;
  padding: 0.3rem 0.5rem;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  /* margin: 4px 2px; */
  cursor: pointer;
  border-radius: 7px;
}

.buy-button img{
    display: inline-block;
    width: 1.2rem;
    margin: 0 .5rem;
}


@media only screen and (max-width: 600px){
    .book-item{
        flex-direction: column-reverse;
        flex-wrap: wrap;
        justify-content: center;
    }
    .book-item > div header{
        flex-direction: column;
    }
    .book-item > div footer{
        /* display: block; */
        align-items: center;
    }

    .buy-button{
        /* display: block; */
        /* width: 100%; */
        margin: 1rem 0;
        padding: 0.7rem 0.5rem;
    }

    .book-cover img{
        display: none;
    }
}
</style>